// Supplier availability requests (docs/reference/SUPPLIER_AVAILABILITY.md).
// Placeholders are filled per supplier by the API (SupplierAvailabilityController::placeholders),
// so one subject and body go to every supplier picked. With one supplier picked the dialog shows
// that supplier's email filled in (preview). {services} is the event's booked services table
// (date/time, rate, groupsize), built in the dialog; empty on a lead with no event.

export const AVAILABILITY_PLACEHOLDERS = [
    '{supplier_name}', '{service_name}', '{group_size}', '{activity_date}', '{event_date}', '{nights}',
    '{location}', '{type}', '{lead_name}', '{team}', '{agent_name}', '{services}', '{available_link}', '{unavailable_link}',
]

export const DEFAULT_AVAILABILITY_SUBJECT = 'Request For Availability - {location} {activity_date}'

export const DEFAULT_AVAILABILITY_BODY =
    '<p>Hi {supplier_name},</p>' +
    '<p>We have a group enquiring and would like to check your availability before we confirm with them:</p>' +
    '<p><strong>Service:</strong> {service_name}<br>' +
    '<strong>Date:</strong> {activity_date}<br>' +
    '<strong>Group size:</strong> {group_size}<br>' +
    '<strong>Location:</strong> {location}</p>' +
    '{services}' +
    '<p>Please let us know by clicking one of the buttons below:</p>' +
    '<p>{available_link} {unavailable_link}</p>' +
    '<p>This is only an availability check, not a booking. We will send a booking request once the group confirms.</p>' +
    '<p>Thanks,<br>{agent_name}<br>{team}</p>'

// Company email templates offered in the request dialog: any whose subject mentions availability.
export const isAvailabilityTemplate = template => /availab/i.test(template?.subject || '')

export const STATUS = {
    waiting: { label: 'Waiting', color: '#FFF3E2', text: '#B26A00', icon: 'mdi-clock-outline' },
    available: { label: 'Available', color: '#E6F3E2', text: '#27AE60', icon: 'mdi-check-circle-outline' },
    unavailable: { label: 'Not Available', color: '#FFEBEE', text: '#C62828', icon: 'mdi-close-circle-outline' },
}

export const CHANNEL_LABELS = { email: 'Email', phone: 'Phone', other: 'Other' }

// "Request Availability" from an Email Supplier menu: the builds' suppliers ticked in the dialog and
// their booked products (build.option_id is the supplier product) picked.
export const availabilityPreset = builds => ({
    supplier_ids: [...new Set(builds.map(build => build.supplier_id))],
    product_ids: [...new Set(builds.map(build => build.option_id).filter(Boolean))],
})
